import { render, staticRenderFns } from "./duoSales.vue?vue&type=template&id=de8f7a94&scoped=true&"
import script from "./duoSales.vue?vue&type=script&lang=js&"
export * from "./duoSales.vue?vue&type=script&lang=js&"
import style0 from "./duoSales.vue?vue&type=style&index=0&id=de8f7a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8f7a94",
  null
  
)

export default component.exports